import axios from "axios";
import Cookies from 'js-cookie';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { useNavigate } from 'react-router-dom'
import React, { useState, useEffect } from "react";
import { usePlaidLink } from "react-plaid-link";
import Navbar from "./NavBar";
import { TailSpin } from 'react-loader-spinner'

import { SiAuthy } from "react-icons/si";
import 'tailwindcss/tailwind.css';

const PlaidIntegration = () => {
  const token = Cookies.get('jwt_token')
  const [mainLoader, setMainLoader] = useState(true)
  const [blinking, setBlinking] = useState('')
  const [reAuthLinkToken, setReAuthLinkToken] = useState(null);
  console.log("re",reAuthLinkToken)
  const [reAuthPublicToken, setReAuthPublicToken] = useState('');
  const [showReAuthSuccess, setShowReAuthSuccess] = useState(false);
  const [syncFailed,setSyncFailed] = useState('')

  const [selectInsId, setSelectInsId] = useState('')
  const [selectInsName, setSelectInsName] = useState('')

  const [accountsLoader, setAccountsLoader] = useState(false)
  const [userAccountsData, setUserAccountsData] = useState([])
  const [userInstitutionsData, setUserInstitutionsData] = useState([])
  const [linkToken, setLinkToken] = useState(null);
  console.log("li",linkToken)

  // eslint-disable-next-line
  const [publicToken, setPublicToken] = useState("");
  // eslint-disable-next-line
  const [accessToken, setAccessToken] = useState("");
  // eslint-disable-next-line
  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const createLinkToken = async () => {
    try {
      const response = await axios.post(
        "https://bankdata.inclineanalytics.com/api/create-link-token", {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        },
      );
      if (response.data.success) {
        const data = response.data;
        setLinkToken(data.link_token);
        setReAuthLinkToken(null)
      }
    } catch (error) {
      console.error("Error creating Link token:", error);
      toast.error("Error creating Link token")
      setLoading(false)
    }
  };

  let { open, ready } = usePlaidLink({
    token: blinking === '' ? linkToken : reAuthLinkToken,
    onSuccess: async (public_token, metadata) => {
      // console.log("onSuccess: public_token", public_token);
      blinking === '' ? setPublicToken(public_token) : setReAuthPublicToken(public_token);
      let url = ''
      if (blinking === '') {
        url = "https://bankdata.inclineanalytics.com/api/get-access-token"
      } else {
        url = "https://bankdata.inclineanalytics.com/api/get-access-token-re-auth"
      }
      try {
        const response = await axios.post(
          url,
          { public_token, selectInsId }, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        },
        );
        if (blinking === '') {
          if (response.data.success) {
            const data = response.data;
            setAccessToken(data.access_token);
            setShowSuccess(true);
          }
        } else {
          if (response.data.success) {
            const data = response.data;
            setAccessToken(data.access_token);
            sendSyncRequest(data.access_token,selectInsId)
            setShowReAuthSuccess(true);
          }
        }

      } catch (error) {
        console.error("Error exchanging public token:", error);
        if (blinking === '') {
          setLoading(false)
        } else {
          setBlinking('')
        }
      }
    },
    onExit: (error, metadata) => {
      setLinkToken(null)
      setReAuthLinkToken(null)
      if (error) {
        toast.error("Error exiting plaid")
      }
      if (blinking === '') {
        setLoading(false)
      } else {
        setBlinking('')
      }
    },
  });

  useEffect(() => {
    // console.log("linkToken:", linkToken);
    // console.log("ready:", ready);
    if (reAuthLinkToken && ready) {
      open();
    }
  }, [reAuthLinkToken, ready, open]);


  useEffect(() => {
    // console.log("linkToken:", linkToken);
    // console.log("ready:", ready);
    if (linkToken && ready) {
      open();
    }
  }, [linkToken, ready, open]);

  useEffect(() => {
    userInstitutions()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (selectInsId !== '') {
      loadAccounts(selectInsId)
    }
    // eslint-disable-next-line
  }, [selectInsId])


  const userInstitutions = async () => {
    try {
      const response = await axios.get(
        "https://bankdata.inclineanalytics.com/api/users/user-institutions",
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        },
      );
      if (response.data.success) {
        setUserInstitutionsData(response.data.data)
        if (response.data.data.length !== 0) {
          setSelectInsId(response.data.data[0].id)
          setSelectInsName(response.data.data[0].insName)

          setAccessToken(response.data.data[0].accessToken)
          setSyncFailed(response.data.data[0].syncFailed)
        }
      }
    } catch (error) {
      console.error("Error fetching user accounts:", error);
    } finally {
      setMainLoader(false)
    }
  }

  const loadAccounts = async (institutionId) => {
    try {
      setAccountsLoader(true)
      const values = {
        institutionId: institutionId,
      }
      const response = await axios.post(
        "https://bankdata.inclineanalytics.com/api/users/user-institutions-accounts",

        values, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      },
      );
      if (response.data.success) {
        setUserAccountsData(response.data.data)
      }
    } catch (error) {
      console.error("Error fetching user accounts:", error);
    } finally {
      setAccountsLoader(false)
    }
  }

  const reAuthAccounts = async (accessToken, selectInsId) => {
    try {
      const response = await axios.post(
        "https://bankdata.inclineanalytics.com/api/re-authorize",
        { accessToken, selectInsId },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        },
      );
      if (response.data.success) {
        const data = response.data;
        // setUserId(data.user_id)
        setReAuthLinkToken(data.link_token);
        setLinkToken(null)
      }
    } catch (error) {
      console.error("Error creating Re-auth Link token:", error);
      toast.error("Error creating Re-auth Link token");
      setBlinking('')
    }
  };

  const sendSyncRequest = async (accessToken, selectInsId) => {
    try {
      const response = await axios.post(
        "https://bankdata.inclineanalytics.com/api/sync-request",
        { accessToken, selectInsId },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        },
      );
      // if (response.data.success) {
      //   const data = response.data;
      //   // setUserId(data.user_id)
      //   setReAuthLinkToken(data.link_token);
      // }
    } catch (error) {
      console.error("Error sending Sync Request:", error);
      toast.error("Error sending Sync Request");
    }
  };

  return (
    <div className="bg-[#001f3f] text-[#ffffff] min-h-[100vh] max-h-fit ">
      <ToastContainer />
      <Navbar />
      {mainLoader ?
        <div className="flex flex-col justify-center items-center h-[80vh]">
          <TailSpin
            visible={true}
            height="80"
            width="80"
            color="#ff6f61"
            ariaLabel="tail-spin-loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass="" /></div> :
        <>{userInstitutionsData.length === 0 ?
          <main style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
            <div style={{ display: "flex", alignItems: "center", maxWidth: "1200px", width: "100%" }}>
              <div style={{ flex: "1", paddingRight: "20px" }}>
                <h1 style={{ fontWeight: "bold", fontSize: "48px", lineHeight: "1.2" }}>
                  Leverage your data <br />
                  <span style={{ color: "#ff6f61" }}>elevate&nbsp;your business</span>
                </h1>
                <p style={{ fontSize: "18px", lineHeight: "1.5", marginTop: "20px" }}>
                  We specialize in advanced analytics tailored for multi-site healthcare companies. We equip our clients with insights and tools to stimulate revenue growth, improve operational efficiencies, streamline cost management, and fortify managerial controls for scalable operations. Through customized analytics solutions, we offer valuable insights that support strategic decision-making, optimize overall performance, and fortify investor relations.
                </p>
                <button onClick={() => {
                  createLinkToken()
                  setLoading(true)
                }} type="button" className="bg-[#ff6f61] text-white py-2 px-4 mt-4 font-medium rounded">
                  {loading ?
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div className="spinner" style={{
                        border: "2px solid rgba(255, 255, 255, 0.3)",
                        borderRadius: "50%",
                        borderTop: "2px solid #fff",
                        width: "20px",
                        height: "20px",
                        animation: "spin 1s linear infinite",
                        marginRight: "10px"
                      }} />
                      Linking...
                    </div> : "Link your bank account"}
                </button>
              </div>
              <div style={{ flex: "1" }}>
                <img src="https://www.inclineanalytics.com/wp-content/uploads/2024/01/IA-Graphic-Bars-Wave-and-Grid-Daniel-Shea-min.png" alt="IA Graphic Bars Wave and Grid Daniel Shea-min" style={{ width: "100%", height: "auto" }} />
              </div>
            </div>
          </main>
          :
          <div className="h-[85vh] lg:p-20 lg:pt-5 pt-0 pb-0  p-5 flex flex-col items-center">
            <div className="w-full lg:flex justify-between items-center ">
              <h1 className="text-[#ff6f61] font-bold text-3xl">Institutions</h1>
              <div className="">
                <button
                  disabled={blinking === selectInsId}
                  onClick={() => {
                    createLinkToken()
                    setLoading(true)
                  }} type="button" className="bg-[#ff6f61] text-white mt-4 lg:mt-0 py-2 px-4 font-medium rounded">
                  {loading ?
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div className="spinner" style={{
                        border: "2px solid rgba(255, 255, 255, 0.3)",
                        borderRadius: "50%",
                        borderTop: "2px solid #fff",
                        width: "20px",
                        height: "20px",
                        animation: "spin 1s linear infinite",
                        marginRight: "10px"
                      }} />
                      Linking...
                    </div> : "Link your bank account"}
                </button>
              </div>
            </div>
            <div className="w-full h-[73vh]  bg-[#ffffff] text-[#000000] rounded-md m-20 mb-0 mt-4 p-10 pt-5">
              <ol className="w-full min-h-[60px] flex scrollbar-thin scrollbar-thumb-gray-800 scrollbar-track-gray-300 overflow-x-auto">
                {userInstitutionsData.map((each) => <li key={each.id}>
                  <button
                    disabled={blinking !== ''}
                    onClick={() => {
                      loadAccounts(each.id)
                      setSelectInsId(each.id)
                      setSelectInsName(each.insName)
                      setAccessToken(each.accessToken)
                      setSyncFailed(each.syncFailed)
                    }}
                    className={`border border-[#ff6f61] hover:border-[2px] hover:shadow-custom-orange m-2 p-2 text-start font-bold rounded-lg ${selectInsId === each.id ? "bg-[#ff6f61] border-none text-[#ffffff]" : 'text-gray-800'}`}>
                    {each.insName}
                  </button>
                </li>)}
              </ol>
              <hr className="border-gray-300 mt-2 w-full" />

              {selectInsId !== '' &&
                <div className="w-full h-[55vh] lg:h-[58vh] scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-300 bg-[#ffffff] text-[#000000] rounded-md mt-2 overflow-y-auto ">
                  {accountsLoader ? <div className="flex flex-col justify-center items-center h-[58vh]">
                    <TailSpin
                      visible={true}
                      height="80"
                      width="80"
                      color="#ff6f61"
                      ariaLabel="tail-spin-loading"
                      radius="1"
                      wrapperStyle={{}}
                      wrapperClass="" /></div> :
                    <ol className="flex w-full flex-wrap p-4 text-md">
                      {syncFailed === true && <div className="w-full flex justify-end">
                        <button
                          disabled={loading === true}
                          onClick={() => {
                            setBlinking(selectInsId)
                            reAuthAccounts(accessToken)
                          }} className={`bg-[#ff6f61] text-white rounded-lg border `}>
                          {blinking === selectInsId ? <p className="m-1 px-2 text-lg animate-blink flex justify-center items-center"><span className="mr-2">Re-Auth Required:</span><span className="mr-2">{selectInsName}</span><SiAuthy /></p> :
                            <p className={ `m-1 px-2 text-lg flex justify-center items-center ${syncFailed && "hover:shadow-custom-orange"}`}><span className="mr-2">Re-Auth Required:</span><span className="mr-2">{selectInsName}</span><SiAuthy /></p>
                          }

                        </button>
                      </div>}
                      
                      {userAccountsData.map((each, index) => <li className="w-full" key={each.id}>
                        <div className="flex justify-between min-h-[130px] max-h-fit border hover:border-[2px] m-2 p-2 pl-5 pr-5 hover:shadow-custom-orange text-start font-bold border-[#ff6f61] rounded-lg">
                          <div className='flex'>
                            <div className="">
                              <p className="mr-2 text-gray-800">{index + 1}.</p>
                            </div>
                            <div>
                              <p className="text-gray-800">Account Name: <span className="font-normal text-gray-900 ml-2">{each.accountName !== null ? each.accountName : "N/A"}</span></p>
                              <p className="mb-4 text-gray-800">Official Name: <span className="font-normal ml-2 text-gray-900">{each.officialName !== null ? each.officialName : "N/A"}</span> (XXXX <span>{each.mask !== null ? each.mask : "N/A"})</span></p>
                              <p className="text-gray-800">Account Type: <span className="font-normal text-gray-900 ml-2">{each.type !== null ? each.type : "N/A"}</span></p>
                              <p className="text-gray-800">Account Sub Type: <span className="font-normal text-gray-900 ml-2">{each.subtype !== null ? each.subtype : "N/A"}</span></p>
                            </div>
                          </div>
                          <div className="flex flex-col justify-end items-end">
                            <p className="text-gray-800">Available Balance:  <span className="font-normal text-gray-900 ml-2">${each.availableBalance !== null ? each.availableBalance : "N/A"}</span></p>
                            <p className="text-gray-800">Current Balance:  <span className="font-normal text-gray-900 ml-2">${each.currentBalance !== null ? each.currentBalance : "N/A"}</span></p>
                          </div>
                        </div>
                      </li>)}
                    </ol>}
                </div>}
            </div>
          </div>}

          {showSuccess && (
            <div style={{
              position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", backgroundColor: "#fff", color: "#000", padding: "20px", borderRadius: "5px", boxShadow: "0 0 10px rgba(0,0,0,0.25)"
            }}>
              <h2 className="text-[#ff6f61] text-xl mb-4 font-bold">Success!</h2>
              <p>Your bank account has been successfully linked.</p>
              <button
                onClick={() => {
                  setShowSuccess(false)
                  setLoading(false)
                  userInstitutions()
                  setLinkToken(null)
                }} style={{ marginTop: "20px", padding: "10px 20px", backgroundColor: "#001f3f", color: "#fff", border: "none", borderRadius: "5px" }}>
                Close
              </button>
            </div>
          )}

          {showReAuthSuccess && ( 
            <div style={{
              position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", backgroundColor: "#fff", color: "#000", padding: "20px", borderRadius: "5px", boxShadow: "0 0 10px rgba(0,0,0,0.25)"
            }}>
              <h2 className="text-[#ff6f61] text-xl mb-4 font-bold">Success!</h2>
              <p>Your bank accounts has been successfully Authorized.</p>
              <button
                onClick={() => {
                  setShowReAuthSuccess(false)
                  setBlinking('')
                  userInstitutions()
                  setReAuthLinkToken(null)
                }} style={{ marginTop: "20px", padding: "10px 20px", backgroundColor: "#001f3f", color: "#fff", border: "none", borderRadius: "5px" }}>
                Close
              </button>
            </div>
          )}

          <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
        </>}
    </div>
  );
};

export default PlaidIntegration;